// How to use the modal:
//
// - add data-action="click->modal#open" to the link that will open the modal.
//
// - In the controller, ensure you render a turbo_stream.update('modal-content', ...), eg
//     render turbo_stream: turbo_stream.update('modal-content', partial: 'my_partial')

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog']

  open (event) {
    this.dialogTarget.showModal()
  }

  close () {
    this.dialogTarget.close()
  }

  clickOutside (event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
